import gql from "graphql-tag";
import {IsnResultWithHeaderFragment} from "./Isn";
import {VeriflytResultFragment} from "./Veriflyt";
import {IcanResultFragment} from "./Ican";
import {CustomerFragment, EmployerFragment, OrganizationFragment} from "./Organization";
import {LocationFragment} from "./Location";
import {PersonComplianceFragment, PersonFragment} from "./Person";

export const ComplianceProviderResultFragment = gql`
    fragment ComplianceProviderResultFragment on ComplianceProviderResult {
        providerType
        checkStatus
        success
        reason
        latencyMs
        startTs
        providerResult
        whitelisted
        error
        nextExpirationDate
        nextExpirationQualificationName
        nextExpirationQualificationID
        _isnResult {
            ...IsnResultWithHeaderFragment
        }
        _veriflytResult {
            ...VeriflytResultFragment
        }
        _icanResult {
            ...IcanResultFragment
        }
    }
    ${IsnResultWithHeaderFragment}
    ${VeriflytResultFragment}
    ${IcanResultFragment}
`

export const ComplianceCheckInPackageFragment = gql`
    fragment ComplianceCheckInPackageFragment on ComplianceCheckInPackage {
        fsPersonID
        fsCustomerID
        fsCustomerDoc {
            ...CustomerFragment
        }
        fsContractorID
        fsContractorDoc {
            ...EmployerFragment
        }
        fsEmployerID
        fsEmployerDoc {
            ...EmployerFragment
        }
        fsDepartureID
        fsDepartureDoc {
            ...LocationFragment
        }
        fsDestinationID
        fsDestinationDoc {
            ...LocationFragment
        }
        isnID
        personVeriflytID
        icanID
        fsRoleID
    }
    ${CustomerFragment}
    ${EmployerFragment}
    ${LocationFragment}
`

export const ComplianceEngineResultFragment = gql`
    fragment ComplianceEngineResultFragment on ComplianceEngineResult {
        checkStatus
        success
        startTs
        complianceCheckerLatencyMs
        policyManagerLatencyMs
        totalLatencyMs
        checkInPackage {
            ...ComplianceCheckInPackageFragment
        }
        causedByProvider
        isnProviderResult {
            ...ComplianceProviderResultFragment
        }
        veriflytProviderResult {
            ...ComplianceProviderResultFragment
        }
        icanProviderResult {
            ...ComplianceProviderResultFragment
        }
        nextExpirationDate {
            nextExpirationDate
            nextExpirationQualificationID
            nextExpirationQualificationName
        }
        error
        policyLog {
            message
        }
    }
    ${ComplianceProviderResultFragment}
    ${ComplianceCheckInPackageFragment}
`

export const PaxNodeComplianceFieldsFragment = gql`
    fragment PaxNodeComplianceFieldsFragment on PaxNode {
        _id
        _rev
        lastName
        firstName
        customerID {
            ...OrganizationFragment
        }
        employerID {
            ...OrganizationFragment
        }
        destinationID {
            ...LocationFragment
        }
        lastComplianceEngineResult {
            ...ComplianceEngineResultFragment
        }
        personID {
            ...PersonComplianceFragment
        }
    }
    ${ComplianceEngineResultFragment}
    ${OrganizationFragment}
    ${LocationFragment}
    ${PersonComplianceFragment}
`

export const PaxNodeComplianceAuthorizationFieldsFragment = gql`
    fragment PaxNodeComplianceAuthorizationFieldsFragment on Authorization {
        onWhiteList
        brdRestriction_Compliance {
            type
            notes
            status
            reason
            overriderTitle
            overriderReason
            redWhiteOverride
            overriderFirstName
            overriderLastName
            approverFirstName
            approverLastName
            createdBy
            createdTs
        }
    }
`

export const PaxNodeComplianceFieldsWithAuthFragment = gql`
    fragment PaxNodeComplianceFieldsWithAuthFragment on PaxNode {
        ...PaxNodeComplianceFieldsFragment
        authorization {
            ...PaxNodeComplianceAuthorizationFieldsFragment
        }
    }
    ${PaxNodeComplianceFieldsFragment}
    ${PaxNodeComplianceAuthorizationFieldsFragment}
`